import { render, staticRenderFns } from "./ResumeCandidature.vue?vue&type=template&id=6cfae6e6"
import script from "./ResumeCandidature.vue?vue&type=script&lang=js"
export * from "./ResumeCandidature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports